
import { PATHS } from './paths.ts';
import { isNonAppPath } from './router.tsx';

export const HOME_PATH = PATHS.home;

export function validatedNext(raw: string | null | undefined): string {
  if (!raw) return HOME_PATH;

  if (!raw.startsWith('/')) return HOME_PATH;
  if (raw.startsWith('//') || raw.startsWith('/\\')) return HOME_PATH;

  let url: URL;
  try {
    url = new URL(raw, 'https://cheddule.invalid');
  } catch {
    return HOME_PATH;
  }
  if (url.origin !== 'https://cheddule.invalid') return HOME_PATH;

  if (url.pathname.startsWith('//')) return HOME_PATH;

  if (isNonAppPath(url.pathname)) return HOME_PATH;

  return url.pathname + url.search;
}
